// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1MIk7","buttons":"SendReceipts_buttons__LK82I","email":"SendReceipts_email__TA706","bookApptTitle":"SendReceipts_bookApptTitle__2Gb7R"};